import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';
import { Checkbox } from './Checkbox';

interface ListItemSelectionProps<TitleType> {
  title: TitleType;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

function ListItemSelection<TitleType extends string>({
  title,
  checked,
  onChange,
  disabled,
}: ListItemSelectionProps<TitleType>): ReactElement {
  return (
    <SelectionWrapper>
      <SelectionCheckbox
        checked={checked}
        onChange={checked => onChange(checked)}
        disabled={disabled}
      >
        {title}
      </SelectionCheckbox>
    </SelectionWrapper>
  );
}

const SelectionWrapper = styled.div`
  &:hover {
    background: ${colorsPalette.lightGray100};
  }
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
`;

const SelectionCheckbox = styled(Checkbox)`
  width: 100%;
`;
export default ListItemSelection;
